module.exports = "/_next/static/images/ThePayoff-xs@2x-72b588d57ebc77e105e930bed9f0cfd4.webp";